import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=20a878ba"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=20a878ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports